<template>
    <div class="text-center">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="400"
            :max-width="$isDesktop() ? '100%' : '90%'"
            max-height="90%"
            bottom
            left
            origin="top right"
            transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on }">
                <v-btn raised elevation="1" min-width="0" text v-on="on">
                    <v-icon>mdi-calendar</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="headline">
                    <p
                        class="dateMenu_v-card-title"
                        :class="{'dateMenu_v-card-title_landscape': !$isDesktop()}">
                        Select Date/Range
                    </p>
                </v-card-title>

                <v-form>
                    <v-list class="pt-0">
                        <v-row>
                            <v-col class="pt-0" cols="12" lg="12">
                                <v-list-item>
                                    <v-card elevation="2">
                                        <div :class="{ datePickerHeader_landscape: !$isDesktop() }" style="padding:1.14rem;background:#607d8b;height:6.42rem;width:100%;display:flex;align-items:flex-end;">
                                            <p class="ma-0 font-weight-bold" style="font-size:1.4rem;color:#FFF;">
                                                {{ inputDateRangeFormatted }}
                                            </p>
                                        </div>
                                        <v-date-picker
                                            v-model="inputDateRange"
                                            :first-day-of-week="1"
                                            class="sdr-custom-date-picker-table"
                                            no-title
                                            color="primary"
                                            range />
                                    </v-card>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </v-list>

                    <!-- >>> Action Buttons -->
                    <v-card-actions style="position:sticky;bottom:0px;background-color:white;padding-bottom:0.71rem;">
                        <v-spacer />
                        <v-btn style="width:8.57rem; font-size:1.14rem;" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_Cancel">
                            Cancel
                        </v-btn>
                        <v-btn class="mr-2" style="width:8.57rem; font-size:1.14rem;" depressed elevation="1" color="primary" @click="onClick_SearchDateRange({ dayjump: false })">
                            Search
                        </v-btn>
                    </v-card-actions>
                    <!-- <<< Action Buttons -->
                </v-form>
            </v-card>
        </v-menu>
    </div>
</template>


<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import dayjs from 'dayjs';

    import { CONF_SCHEDULER_TIME_RANGE_DAYS } from '../../../../../config';
    import { eventBus } from '../../../../../main';
    import isBetween from 'dayjs/plugin/isBetween';
    dayjs.extend(isBetween);


    export default {
        name: 'FlightsDateMenue',

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                menu: false,
                // ------------------------------------------------------------- Date Range Menu
                inputDateRange: [dayjs().format('YYYY-MM-DD'), dayjs().add(CONF_SCHEDULER_TIME_RANGE_DAYS, 'days').format('YYYY-MM-DD')],
                inputDateRangeFormatted: [dayjs().format('DD.MM.YYYY'), dayjs().add(CONF_SCHEDULER_TIME_RANGE_DAYS, 'days').format('DD.MM.YYYY')].join(' - ')
                // TODO: cleanup
                // aircrafts: [
                //     { code: 'D-ANNA' },
                //     { code: 'D-ASGK' },
                //     { code: 'D-ASMR' },
                //     { code: 'D-ASSB' },
                //     { code: 'D-ASSM' },
                //     { code: 'SUB1' },
                //     { code: 'SUB2' },
                //     { code: 'FlyAir 9A-BER' },
                //     { code: 'FlyAir 9A-IRM' },
                //     { code: 'FlyAir 9A-SHO' },
                //     { code: 'FlyAir 9A-ZAG' }
                // ],
                // aircraftsFlyAir41: [
                //     { code: '9A-BER' },
                //     { code: '9A-IRM' },
                //     { code: '9A-SHO' },
                //     { code: '9A-ZAG' },
                //     { code: 'D-ASGK' },
                //     { code: 'D-ASMR' },
                //     { code: 'D-ASSB' },
                //     { code: 'D-ASSM' },
                //     { code: 'D-ANNA' }
                // ]
            };

        }, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
                'get_AircraftConfigs',
                'get_flights_StartDate',
                'get_flights_EndDate',
                'get_flights_Resources_Filtered',
                'get_flights_OCCMode'
			])

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
			* menu()
			*
			* Desc: Close other menus if this menu opens.
            * Note:
            *
			*/
            menu (val) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> watch/menu');
                if (val === true) {
                    // trigger event for other menus to close
                    eventBus.$emit('menuopen');
                }

            }, // eo function menu()


            /*******************************************************************
			* inputDateRange()
			*
			* Desc:
            * Note:
            *
			*/
            inputDateRange (val) {

                const me = this;
                const formattedDates = [];


                me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> watch/inputDateRange');
                //if there are two dates selcted (range)
                //check if the first date is NOT before the second date
                if (val.length === 2) {
                    //switch dates, so the range is valid
                    if (dayjs(val[0]).isAfter(dayjs(val[1]))) {
                        //switch val[0] und val[1]
                        [val[0], val[1]] = [val[1], val[0]];
                    }
                }

                //loop over date range, and save formatted date
                me.inputDateRange.forEach(date => {
                    formattedDates.push(dayjs(date).format('DD.MM.YYYY'));
                });

                me.inputDateRangeFormatted = formattedDates.join(' - ');

            } // eo function inputDateRange()

        }, // eo watch{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> created');
            me.onClick_SearchDateRange({ dayjump: false });

            eventBus.$on('switchDateSelected', me.onChange_switchToDate);
            eventBus.$on('datebackwards', me.onChange_dateBackwards);
            eventBus.$on('dateforwards', me.onChange_dateForwards);

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> destroyed');
            eventBus.$off('switchDateSelected', me.onChange_switchToDate);
            eventBus.$off('datebackwards', me.onChange_dateBackwards);
            eventBus.$off('dateforwards', me.onChange_dateForwards);

		}, // eo function destroyed()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setCalendarDates',
                'actn_setFlightsSchedulerPreset'
            ]),


            /*******************************************************************
            * Listeners:
            *******************************************************************/
            /*******************************************************************
			* onChange_dateForwards()
			*
			* Desc: Go forward [days] days in the date range.
            * Note: Only go forward if startDate is equal to endDate.
            *
            * @param {number} days (days to go forward)
			*/
            onChange_dateForwards: function(days) {

                const me = this;
                const dateRange = [];


                me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> onChange_dateForwards');
                if (me.inputDateRange[0] === me.inputDateRange[1]) {
                    dateRange.push(dayjs(me.inputDateRange[0]).add(days, 'days').format('YYYY-MM-DD'));
                    dateRange.push(dayjs(me.inputDateRange[1]).add(days, 'days').format('YYYY-MM-DD'));
                    me.inputDateRange = dateRange;

                    me.onClick_SearchDateRange({ dayjump: true });
                }

            }, // eo function onChange_dateForwards()


            /*******************************************************************
			* onChange_dateBackwards()
			*
			* Desc: Go backwards [days] days in the date range.
            * Note: Only go backwards if startDate is equal to endDate.
            *
            * @param {number} days (days to go backward)
			*/
            onChange_dateBackwards: function(days) {

                const me = this;
                const dateRange = [];


                me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> onChange_dateBackwards');
                if (me.inputDateRange[0] === me.inputDateRange[1]) {
                    dateRange.push(dayjs(me.inputDateRange[0]).subtract(days, 'days').format('YYYY-MM-DD'));
                    dateRange.push(dayjs(me.inputDateRange[1]).subtract(days, 'days').format('YYYY-MM-DD'));
                    me.inputDateRange = dateRange;

                    me.onClick_SearchDateRange({ dayjump: true });
                }

            }, // eo function onChange_dateBackwards()


            /*******************************************************************
			* onClick_SummerFlightPlan()
			*
			* Desc:
            * Note:
            *
			*/
            onClick_SummerFlightPlan: function() {

                const me = this;
                let summerFlightPlan_start = null,
                    summerFlightPlan_end = null;


                me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> onClick_SummerFlightPlan');
                summerFlightPlan_start = dayjs().set('date', 1).set('month', 5);
                summerFlightPlan_end = dayjs().set('date', 31).set('month', 9);
                me.inputDateRange = [summerFlightPlan_start, summerFlightPlan_end];
                // me.onClick_SearchDateRange();

            }, // eo function onClick_SummerFlightPlan()


            /*******************************************************************
			* onClick_SearchDateRange()
			*
			* Desc: Close Date Range Menu and trigger Call.
            * Note: Params for Call, dateRange for Schedluer.
            * Note: If there is only one date picked, build a range with
            * Note: identical start and end date.
            * Note: If dayjump === true, do NOT trigger a reset of the
            * Note: highlight terms.
            *
            * @param {object} options { dayjump: boolean }
			*/
			onClick_SearchDateRange: function(options) {

                const me = this;
                      //aircraftsFromCarrier = CONF_CLIENT === 'Sundair' ? me.aircrafts  : me.aircraftsFlyAir41;
                let params = null,
                    dateRange = null,
                    includeMVT = false;

                me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> onClick_SearchDateRange');
                if (me.inputDateRange.length === 1) {
                    me.inputDateRange.push(me.inputDateRange[0]);
                }

                if (dayjs().isBetween(me.inputDateRange[0], me.inputDateRange[1], 'day', '[]')) {
                    includeMVT = true;
                }

                params = {
                    flightNo: null,
                    from: dayjs(me.inputDateRange[0]).format('YYYY-MM-DDT00:00:00[Z]'), //"2021-04-30T00:00:01Z"
                    fromAptCode: null,
                    idFlight: null,
                    to: dayjs(me.inputDateRange[1]).format('YYYY-MM-DDT23:59:59[Z]'),   //"2021-04-30T23:59:59Z"
                    toAptCode: null,
                    DOW: [],
                    idAircraftConfig: me.get_AircraftConfigs.map(aircraft => {
                        return aircraft.id;
                    }),
                    includeMVT: includeMVT
                    // TODO: clean up
                    // idAircraftConfig: me.get_flights_Resources_Filtered.length > 0    // (used for date range changes),
                    //     ? me.get_flights_Resources_Filtered.map(r => r.idAircraft)      // (used only once @start),
                    //     : aircraftsFromCarrier.map(a => {
                    //         // necessary to look for equal codes because
                    //         // id & idAircraft are different on LIVE and TEST
                    //         const foundAircraftConfig = me.get_AircraftConfigs.find(b => a.code === b.code);
                    //         if (!Vue.prototype.$isEmpty(foundAircraftConfig)) {
                    //             return foundAircraftConfig.id;
                    //         }

                    //         // >>> CAR: added undefined as default return value,
                    //         // otherwise this function returns null and map
                    //         // will create an array like [null, null, null, ...]
                    //         return undefined;
                    //         // <<< CAR added undefined
                    //     })
                };

                dateRange = {
                    startDate: dayjs(me.inputDateRange[0]),
                    endDate: dayjs(me.inputDateRange[1])
                };

                me.menu = false;
                me.actn_setCalendarDates({ params, dateRange });

            }, // eo function onClick_SearchDateRange()


            /*******************************************************************
			* onClick_Cancel()
			*
			* Desc: Reset the selected date to the current date after canceling.
            * Note:
            *
			*/
            onClick_Cancel: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/core/DateMenue.vue >>> onClick_Cancel');
                me.menu = false;
                me.inputDateRange = [me.get_flights_StartDate.format('YYYY-MM-DD'), me.get_flights_EndDate.format('YYYY-MM-DD')];

            } //eo function onClick_Cancel()

        } // eof methods()
        /* <<< ****************************************************************/

    };
</script>


<style>
    .v-select.v-select--chips.v-select--chips--small .v-select__selections {
        min-height: 0px !important; /* 26px */
    }

    .v-label {
        font-size: 14px !important; /* 16px */
    }

    .v-select.v-select--chips input {
        min-height: 42px;
    }

    .v-btn__content {
        font-size: 12px;
    }

    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    div.v-date-picker-table.v-date-picker-table--date.theme--light {
        height: unset !important;
        padding-bottom: 4px;
    }
    .v-date-picker-years li.active {
    color:white!important;
    }
</style>

<style scoped>
    .v-toolbar__content .v-btn--flat {
        margin-left: 0 !important;
    }
    .dateMenu_v-card-title {
        padding-left: 2rem;
        margin: 2.28rem 0;
    }
    .dateMenu_v-card-title_landscape {
        margin: 1rem 0;
    }
    .datePickerHeader_landscape {
        height: unset !important;
    }

</style>
